import { render, staticRenderFns } from "./HistoryListComponent.vue?vue&type=template&id=e903d608&scoped=true&"
import script from "./HistoryListComponent.vue?vue&type=script&lang=js&"
export * from "./HistoryListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e903d608",
  null
  
)

export default component.exports